import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { GraphQLError } from "graphql";
import type { Grid } from "@/API";
import { getGrids as getGridsQuery } from "@/graphql/queries";

const client = generateClient();

export const getGridsState = create<State<Grid[]>>(() => ({
  data: [],
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getGridsIsloading = () =>
  getGridsState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: [],
    error: null,
  }));
export const getGridsIsError = (error: GraphQLError[] | undefined) =>
  getGridsState.setState(() => ({
    error: error,
    data: [],
    isLoading: false,
    isFetching: false,
  }));
export const getGridsIsSuccess = (queryResult: Grid[]) =>
  getGridsState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetUserRestaurantsState = () =>
  getGridsState.setState(() => getGridsState.getInitialState());

export const getGrids = async () => {
  getGridsIsloading();

  try {
    const { data } = await client.graphql({
      query: getGridsQuery,
    });

    getGridsIsSuccess(data.getGrids as Grid[]);
  } catch (e) {
    const graphQl = e as GraphQLResult<Grid[]>;
    getGridsIsError(graphQl.errors);
  }
};

export const addGridInGrids = (grid: Grid) => {
  const { data } = getGridsState.getState();
  if (data) {
    const copyData = [...data];
    copyData.push(grid);
    getGridsState.setState(() => ({
      data: copyData,
      isLoading: false,
      error: null,
      isFetching: false,
    }));
  }
};

export const removeGridInGrids = (gridId: string) => {
  const { data } = getGridsState.getState();
  if (data) {
    let copyData = data.filter((grid) => grid.id !== gridId);

    getGridsState.setState(() => ({
      data: copyData,
      isLoading: false,
      error: null,
      isFetching: false,
    }));
  }
};

export const updateGridInGrids = (grid: Grid) => {
  const { data } = getGridsState.getState();
  if (data) {
    let copyData = [...data];
    const index = copyData.findIndex((g) => g.id === grid.id);

    copyData[index] = grid;

    getGridsState.setState(() => ({
      data: copyData,
      isLoading: false,
      error: null,
      isFetching: false,
    }));
  }
};
